import { useState, useEffect } from 'react';

let listenerAdded = false;

function useIsMobile() {
  const [isMobile, setIsMobile] = useState(window.innerWidth < 768);

  useEffect(() => {
    if (!listenerAdded) {
      const handleResize = () => {
        setIsMobile(window.innerWidth < 768);
      };

      window.addEventListener('resize', handleResize);

      listenerAdded = true;

      return () => {
        window.removeEventListener('resize', handleResize);
        listenerAdded = false;
      };
    }
  }, []);

  return isMobile;
}
export default useIsMobile;
